import React, { Component } from 'react';


class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }
    render() {
        return (
            <div className="row footer">
                <div className="col footer-copyright">
                    COPYRIGHT MEVU 2018
                </div>
                <div className="col footer-menu">
                    <ul>
                        <a href="https://mevu.bet/#desc"><li>About</li></a>
                        <a href="https://mevu.bet/#team"><li>Team</li></a>
                        <a href="https://mevu.bet/#cta"><li>Contact</li></a>
                        <a href="https://github.com/mevu-bet/mevu" target="_blank"><li>Github</li></a>
                    </ul>
                </div>

            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js